<template>
  <section>
    <dns-create :isTenant="isTenant" :account="account" :loading="loading" v-on:update-list="list" v-on:update-loading="updateLoading"></dns-create>
    <dns-items ref="dnsItems" :index="index" :selectedAlias="account.domain" :isTenant="isTenant"  :records="records" :account="account" :loading="loading" v-on:update-list="list" v-on:update-loading="updateLoading"></dns-items>
  </section>
</template>

<script>
import swal from "sweetalert2";
import _ from "lodash";

import DnsItems from "./dnsItems";
import DnsCreate from "./dnsCreate";
export default {
  name: "dns",
  components: {
    DnsItems,
    DnsCreate,
  },
  props: {
    index: {
      type: Number
    },
    records: {
      type: Array
    },
    loading: {
      type: Boolean
    },
    account: {
      type: Object
    },
    fromAlias: {
      type: Boolean
    },
    selectedAlias: {
      type: String
    },
  },
  data: function () {
    return {
      isTenant: true,
      domain: '',
      file: '',
      loadingData: false,
      editItem: {},
      action: null,
      actions:[
        {
          name: 'BigScoots Default',
          action: '0'
        },
        {
          name: 'GSuite',
          action: '1'
        }
      ],
      selectedAction:'',
    }
  },
  methods: {
    update(){
      this.action = 'update';
      this.$refs.dnsItems.editItem = Object.assign({}, this.editItem);
      this.$refs.dnsItems.update();
    },
    openModal(el){
      console.log('modal called', el)
      /* eslint-disable */
      $("#" + el).modal("show");
      $('.modal-backdrop').removeClass("modal-backdrop");
      /* eslint-enable */
    },
    list() {
      console.log(this.account)
      this.$parent.fetchAllDNS()
    },
    importRecords(event) {
      this.file = this.$refs.file.files[0];
      let formData = new FormData();
      formData.append('importFile', this.file);
      formData.append('grant_type', "token");
      formData.append('token', this.userToken);
      formData.append('cloudflare_email', this.account.cloudflare.username);
      formData.append('cloudflare_api_key', this.account.cloudflare.apiKey);
      formData.append('cloudflare_zone', this.account.cloudflare.zone_id);
      formData.append('domain', this.account.domain);

      this.$http(
          {
            method: 'post',
            url: '/dns/import',
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            data: formData
          }
      ).then((response) => {
        this.list();
        const { result, messages } = response.data.data;
        let message = '';
        if(messages){
          messages.map(item=>message += `<p>${item.message}</p>`);
        }
        swal({
          title: "Message!",
          html: `<p>You successfully imported DNS records.</p> <p>Records added: ${result.recs_added}.</p><p>Total records parsed: ${result.total_records_parsed}</p> ${message}`,
          type: "success",
          confirmButtonText: "OK!",
          confirmButtonColor: "#EE8057"
        });
      })
          .catch((err) => {
            let responseMessage = err.response.data.message;
            if (err.response.status === 422) {
              responseMessage = _.map(err.response.data.errors, 'msg').join('. ')
            }else if(err.response.status === 401){
              responseMessage = "You need update token. Please Try Again!";
              this.refreshToken();
            }

            swal({
              title: "Something went wrong!",
              html: responseMessage,
              type: "error",
              confirmButtonText: "Try Again!",
              confirmButtonColor: "#EE8057"
            });
            this.addLog({
              name: this.user.firstName + " " + this.user.lastName,
              message: "Error import DNS records. Message: " + responseMessage,
              level: "danger"
            });
          })
          .finally(() => {
            this.file = null;
            event.target.value = '';
          });
    },
    updateLoading(value){
      this.$emit('update-loading', value)
    }
  }

}
</script>

<style scoped>

</style>